module.exports = __webpack_public_path__ + "img/179954.ffd25b8b.png";